import Vue from 'vue';
import Router from 'vue-router';
import { interopDefault } from './utils';

const _a37d6112 = () => interopDefault(import('../pages/monitoring.vue'
/* webpackChunkName: "pages/monitoring" */
));

const _b448840a = () => interopDefault(import('../pages/redirect_url.vue'
/* webpackChunkName: "pages/redirect_url" */
));

const _0df5f5ae = () => interopDefault(import('../pages/tools/grid.vue'
/* webpackChunkName: "pages/tools/grid" */
));

const _565d3527 = () => interopDefault(import('../pages/_market/_language/index.vue'
/* webpackChunkName: "pages/_market/_language/index" */
));

const _539f159e = () => interopDefault(import('../pages/_market/_language/cart/index.vue'
/* webpackChunkName: "pages/_market/_language/cart/index" */
));

const _15791702 = () => interopDefault(import('../pages/_market/_language/help/index.vue'
/* webpackChunkName: "pages/_market/_language/help/index" */
));

const _3291b841 = () => interopDefault(import('../pages/_market/_language/login/index.vue'
/* webpackChunkName: "pages/_market/_language/login/index" */
));

const _4050e588 = () => interopDefault(import('../pages/_market/_language/lost-password/index.vue'
/* webpackChunkName: "pages/_market/_language/lost-password/index" */
));

const _3d9bf0d7 = () => interopDefault(import('../pages/_market/_language/reset-password/index.vue'
/* webpackChunkName: "pages/_market/_language/reset-password/index" */
));

const _5b6ba8d6 = () => interopDefault(import('../pages/_market/_language/signup/index.vue'
/* webpackChunkName: "pages/_market/_language/signup/index" */
));

const _1763fb4d = () => interopDefault(import('../pages/_market/_language/sitemap/index.vue'
/* webpackChunkName: "pages/_market/_language/sitemap/index" */
));

const _9d0bb37c = () => interopDefault(import('../pages/_market/_language/store-locator/index.vue'
/* webpackChunkName: "pages/_market/_language/store-locator/index" */
));

const _6c9eec89 = () => interopDefault(import('../pages/_market/_language/user/index.vue'
/* webpackChunkName: "pages/_market/_language/user/index" */
));

const _94bf4ba6 = () => interopDefault(import('../pages/_market/_language/help/confirm.vue'
/* webpackChunkName: "pages/_market/_language/help/confirm" */
));

const _0b680099 = () => interopDefault(import('../pages/_market/_language/help/deliveryConfirm.vue'
/* webpackChunkName: "pages/_market/_language/help/deliveryConfirm" */
));

const _2e9c8328 = () => interopDefault(import('../pages/_market/_language/poc/grid.vue'
/* webpackChunkName: "pages/_market/_language/poc/grid" */
));

const _7c1beaea = () => interopDefault(import('../pages/_market/_language/s/catalogue-luminaires.vue'
/* webpackChunkName: "pages/_market/_language/s/catalogue-luminaires" */
));

const _5c14dab7 = () => interopDefault(import('../pages/_market/_language/s/home-by-me.vue'
/* webpackChunkName: "pages/_market/_language/s/home-by-me" */
));

const _ac3521ba = () => interopDefault(import('../pages/_market/_language/s/lighting.vue'
/* webpackChunkName: "pages/_market/_language/s/lighting" */
));

const _47bfbdb8 = () => interopDefault(import('../pages/_market/_language/s/sustainable-development.vue'
/* webpackChunkName: "pages/_market/_language/s/sustainable-development" */
));

const _173aadce = () => interopDefault(import('../pages/_market/_language/t/confirmed.vue'
/* webpackChunkName: "pages/_market/_language/t/confirmed" */
));

const _58515daa = () => interopDefault(import('../pages/_market/_language/t/delivery.vue'
/* webpackChunkName: "pages/_market/_language/t/delivery" */
));

const _0d67e123 = () => interopDefault(import('../pages/_market/_language/t/login.vue'
/* webpackChunkName: "pages/_market/_language/t/login" */
));

const _76b3195e = () => interopDefault(import('../pages/_market/_language/t/lost-password.vue'
/* webpackChunkName: "pages/_market/_language/t/lost-password" */
));

const _308da680 = () => interopDefault(import('../pages/_market/_language/t/payment.vue'
/* webpackChunkName: "pages/_market/_language/t/payment" */
));

const _4ee556cc = () => interopDefault(import('../pages/_market/_language/t/payment-paypal-pending.vue'
/* webpackChunkName: "pages/_market/_language/t/payment-paypal-pending" */
));

const _1610aeec = () => interopDefault(import('../pages/_market/_language/t/refused.vue'
/* webpackChunkName: "pages/_market/_language/t/refused" */
));

const _28239f64 = () => interopDefault(import('../pages/_market/_language/t/signup.vue'
/* webpackChunkName: "pages/_market/_language/t/signup" */
));

const _75651d42 = () => interopDefault(import('../pages/_market/_language/user/gift-cards.vue'
/* webpackChunkName: "pages/_market/_language/user/gift-cards" */
));

const _31b5d67e = () => interopDefault(import('../pages/_market/_language/user/orders/index.vue'
/* webpackChunkName: "pages/_market/_language/user/orders/index" */
));

const _8be403c0 = () => interopDefault(import('../pages/_market/_language/user/profile.vue'
/* webpackChunkName: "pages/_market/_language/user/profile" */
));

const _5bab6ca3 = () => interopDefault(import('../pages/_market/_language/user/profile/index.vue'
/* webpackChunkName: "pages/_market/_language/user/profile/index" */
));

const _753912f3 = () => interopDefault(import('../pages/_market/_language/user/profile/addresses.vue'
/* webpackChunkName: "pages/_market/_language/user/profile/addresses" */
));

const _63582e96 = () => interopDefault(import('../pages/_market/_language/user/profile/alerts.vue'
/* webpackChunkName: "pages/_market/_language/user/profile/alerts" */
));

const _1128a081 = () => interopDefault(import('../pages/_market/_language/user/profile/FormAddress.vue'
/* webpackChunkName: "pages/_market/_language/user/profile/FormAddress" */
));

const _7a49f24c = () => interopDefault(import('../pages/_market/_language/user/profile/password.vue'
/* webpackChunkName: "pages/_market/_language/user/profile/password" */
));

const _2fc00b5e = () => interopDefault(import('../pages/_market/_language/user/wishlist.vue'
/* webpackChunkName: "pages/_market/_language/user/wishlist" */
));

const _324324f9 = () => interopDefault(import('../pages/_market/_language/configurator/product/_model.vue'
/* webpackChunkName: "pages/_market/_language/configurator/product/_model" */
));

const _4c38d374 = () => interopDefault(import('../pages/_market/_language/e/magazine/_slug.vue'
/* webpackChunkName: "pages/_market/_language/e/magazine/_slug" */
));

const _255d9ca1 = () => interopDefault(import('../pages/_market/_language/help/contact/_form.vue'
/* webpackChunkName: "pages/_market/_language/help/contact/_form" */
));

const _58b9ddd1 = () => interopDefault(import('../pages/_market/_language/help/faq/_answer.vue'
/* webpackChunkName: "pages/_market/_language/help/faq/_answer" */
));

const _32f550e7 = () => interopDefault(import('../pages/_market/_language/help/return/_form.vue'
/* webpackChunkName: "pages/_market/_language/help/return/_form" */
));

const _be23db26 = () => interopDefault(import('../pages/_market/_language/user/orders/_reference.vue'
/* webpackChunkName: "pages/_market/_language/user/orders/_reference" */
));

const _e39c0e90 = () => interopDefault(import('../pages/_market/_language/c/_alias.vue'
/* webpackChunkName: "pages/_market/_language/c/_alias" */
));

const _67197a4e = () => interopDefault(import('../pages/_market/_language/configurator/_model.vue'
/* webpackChunkName: "pages/_market/_language/configurator/_model" */
));

const _3dc319bf = () => interopDefault(import('../pages/_market/_language/inspirations/_slug.vue'
/* webpackChunkName: "pages/_market/_language/inspirations/_slug" */
));

const _1b9142ea = () => interopDefault(import('../pages/_market/_language/p/_alias.vue'
/* webpackChunkName: "pages/_market/_language/p/_alias" */
));

const _17985e83 = () => interopDefault(import('../pages/_market/_language/q/_keyword.vue'
/* webpackChunkName: "pages/_market/_language/q/_keyword" */
));

const _0f8c3831 = () => interopDefault(import('../pages/_market/_language/e/_alias/_slug.vue'
/* webpackChunkName: "pages/_market/_language/e/_alias/_slug" */
));

const _d3e9a946 = () => interopDefault(import('../pages/_market/_language/index.vue'
/* webpackChunkName: "" */
));

const _63bd6b49 = () => interopDefault(import('../pages/_market/_language/inspirations/_slug.vue'
/* webpackChunkName: "" */
));

const _52a6eaad = () => interopDefault(import('../pages/_market/_language/s/lighting.vue'
/* webpackChunkName: "" */
));

const _4b34c87e = () => interopDefault(import('../pages/_market/_language/s/home-by-me.vue'
/* webpackChunkName: "" */
));

const _3cb0debb = () => interopDefault(import('../pages/_market/_language/e/_alias/_slug.vue'
/* webpackChunkName: "" */
));

const _4aca05f8 = () => interopDefault(import('../pages/_market/_language/store-locator/index.vue'
/* webpackChunkName: "" */
));

Vue.use(Router);

if (process.client) {
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual'; // reset scrollRestoration to auto when leaving page, allowing page reload
    // and back-navigation from other pages to use the browser to restore the
    // scrolling position.

    window.addEventListener('beforeunload', () => {
      window.history.scrollRestoration = 'auto';
    }); // Setting scrollRestoration to manual again when returning to this page.

    window.addEventListener('load', () => {
      window.history.scrollRestoration = 'manual';
    });
  }
}

const scrollBehavior = function scrollBehavior(to, from, savedPosition) {
  // if the returned position is falsy or an empty object,
  // will retain current scroll position.
  let position = false; // if no children detected and scrollToTop is not explicitly disabled

  if (to.matched.length < 2 && to.matched.every(r => r.components.default.options.scrollToTop !== false)) {
    // scroll to the top of the page
    position = {
      x: 0,
      y: 0
    };
  } else if (to.matched.some(r => r.components.default.options.scrollToTop)) {
    // if one of the children has scrollToTop option set to true
    position = {
      x: 0,
      y: 0
    };
  } // savedPosition is only available for popstate navigations (back button)


  if (savedPosition) {
    position = savedPosition;
  }

  return new Promise(resolve => {
    // wait for the out transition to complete (if necessary)
    window.$nuxt.$once('triggerScroll', () => {
      // coords will be used if no selector is provided,
      // or if the selector didn't match any element.
      if (to.hash) {
        let hash = to.hash; // CSS.escape() is not supported with IE and Edge.

        if (typeof window.CSS !== 'undefined' && typeof window.CSS.escape !== 'undefined') {
          hash = '#' + window.CSS.escape(hash.substr(1));
        }

        try {
          if (document.querySelector(hash)) {
            // scroll to anchor by returning the selector
            position = {
              selector: hash
            };
          }
        } catch (e) {
          console.warn('Failed to save scroll position. Please add CSS.escape() polyfill (https://github.com/mathiasbynens/CSS.escape).');
        }
      }

      resolve(position);
    });
  });
};

export function createRouter() {
  return new Router({
    mode: 'history',
    base: decodeURI('/'),
    linkActiveClass: 'nuxt-link-active',
    linkExactActiveClass: 'nuxt-link-exact-active',
    scrollBehavior,
    routes: [{
      path: "/monitoring",
      component: _a37d6112,
      name: "monitoring"
    }, {
      path: "/redirect_url",
      component: _b448840a,
      name: "redirect_url"
    }, {
      path: "/tools/grid",
      component: _0df5f5ae,
      name: "tools-grid"
    }, {
      path: "/:market/:language",
      component: _565d3527,
      name: "market-language"
    }, {
      path: "/:market/:language/cart",
      component: _539f159e,
      name: "market-language-cart"
    }, {
      path: "/:market/:language/help",
      component: _15791702,
      name: "market-language-help"
    }, {
      path: "/:market/:language/login",
      component: _3291b841,
      name: "market-language-login"
    }, {
      path: "/:market/:language/lost-password",
      component: _4050e588,
      name: "market-language-lost-password"
    }, {
      path: "/:market/:language/reset-password",
      component: _3d9bf0d7,
      name: "market-language-reset-password"
    }, {
      path: "/:market/:language/signup",
      component: _5b6ba8d6,
      name: "market-language-signup"
    }, {
      path: "/:market/:language/sitemap",
      component: _1763fb4d,
      name: "market-language-sitemap"
    }, {
      path: "/:market/:language/store-locator",
      component: _9d0bb37c,
      name: "market-language-store-locator"
    }, {
      path: "/:market/:language/user",
      component: _6c9eec89,
      name: "market-language-user"
    }, {
      path: "/:market/:language/help/confirm",
      component: _94bf4ba6,
      name: "market-language-help-confirm"
    }, {
      path: "/:market/:language/help/deliveryConfirm",
      component: _0b680099,
      name: "market-language-help-deliveryConfirm"
    }, {
      path: "/:market/:language/poc/grid",
      component: _2e9c8328,
      name: "market-language-poc-grid"
    }, {
      path: "/:market/:language/s/catalogue-luminaires",
      component: _7c1beaea,
      name: "market-language-s-catalogue-luminaires"
    }, {
      path: "/:market/:language/s/home-by-me",
      component: _5c14dab7,
      name: "market-language-s-home-by-me"
    }, {
      path: "/:market/:language/s/lighting",
      component: _ac3521ba,
      name: "market-language-s-lighting"
    }, {
      path: "/:market/:language/s/sustainable-development",
      component: _47bfbdb8,
      name: "market-language-s-sustainable-development"
    }, {
      path: "/:market/:language/t/confirmed",
      component: _173aadce,
      name: "market-language-t-confirmed"
    }, {
      path: "/:market/:language/t/delivery",
      component: _58515daa,
      name: "market-language-t-delivery"
    }, {
      path: "/:market/:language/t/login",
      component: _0d67e123,
      name: "market-language-t-login"
    }, {
      path: "/:market/:language/t/lost-password",
      component: _76b3195e,
      name: "market-language-t-lost-password"
    }, {
      path: "/:market/:language/t/payment",
      component: _308da680,
      name: "market-language-t-payment"
    }, {
      path: "/:market/:language/t/payment-paypal-pending",
      component: _4ee556cc,
      name: "market-language-t-payment-paypal-pending"
    }, {
      path: "/:market/:language/t/refused",
      component: _1610aeec,
      name: "market-language-t-refused"
    }, {
      path: "/:market/:language/t/signup",
      component: _28239f64,
      name: "market-language-t-signup"
    }, {
      path: "/:market/:language/user/gift-cards",
      component: _75651d42,
      name: "market-language-user-gift-cards"
    }, {
      path: "/:market/:language/user/orders",
      component: _31b5d67e,
      name: "market-language-user-orders"
    }, {
      path: "/:market/:language/user/profile",
      component: _8be403c0,
      children: [{
        path: "",
        component: _5bab6ca3,
        name: "market-language-user-profile"
      }, {
        path: "addresses",
        component: _753912f3,
        name: "market-language-user-profile-addresses"
      }, {
        path: "alerts",
        component: _63582e96,
        name: "market-language-user-profile-alerts"
      }, {
        path: "FormAddress",
        component: _1128a081,
        name: "market-language-user-profile-FormAddress"
      }, {
        path: "password",
        component: _7a49f24c,
        name: "market-language-user-profile-password"
      }]
    }, {
      path: "/:market/:language/user/wishlist",
      component: _2fc00b5e,
      name: "market-language-user-wishlist"
    }, {
      path: "/:market/:language/configurator/product/:model?",
      component: _324324f9,
      name: "market-language-configurator-product-model"
    }, {
      path: "/:market/:language/e/magazine/:slug?",
      component: _4c38d374,
      name: "market-language-e-magazine-slug"
    }, {
      path: "/:market/:language/help/contact/:form?",
      component: _255d9ca1,
      name: "market-language-help-contact-form"
    }, {
      path: "/:market/:language/help/faq/:answer?",
      component: _58b9ddd1,
      name: "market-language-help-faq-answer"
    }, {
      path: "/:market/:language/help/return/:form?",
      component: _32f550e7,
      name: "market-language-help-return-form"
    }, {
      path: "/:market/:language/user/orders/:reference?",
      component: _be23db26,
      name: "market-language-user-orders-reference"
    }, {
      path: "/:market/:language/c/:alias?",
      component: _e39c0e90,
      name: "market-language-c-alias"
    }, {
      path: "/:market/:language/configurator/:model?",
      component: _67197a4e,
      name: "market-language-configurator-model"
    }, {
      path: "/:market/:language/inspirations/:slug?",
      component: _3dc319bf,
      name: "market-language-inspirations-slug"
    }, {
      path: "/:market/:language/p/:alias?",
      component: _1b9142ea,
      name: "market-language-p-alias"
    }, {
      path: "/:market/:language/q/:keyword?",
      component: _17985e83,
      name: "market-language-q-keyword"
    }, {
      path: "/:market/:language/e/:alias?/:slug?",
      component: _0f8c3831,
      name: "market-language-e-alias-slug"
    }, {
      path: "/",
      component: _d3e9a946,
      name: "market-language-home-fr"
    }, {
      path: "/:market/:language/inspirations*",
      component: _63bd6b49,
      name: "market-language-inspirations-fr"
    }, {
      path: "/:market/:language/inspirationen*",
      component: _63bd6b49,
      name: "market-language-inspirations-de"
    }, {
      path: "/:market/:language/ispirazione*",
      component: _63bd6b49,
      name: "market-language-inspirations-it"
    }, {
      path: "/:market/:language/inspiration*",
      component: _63bd6b49,
      name: "market-language-inspirations-en"
    }, {
      path: "/:market/:language/inspiration*",
      component: _63bd6b49,
      name: "market-language-inspirations-pt"
    }, {
      path: "/:market/:language/inspiracion*",
      component: _63bd6b49,
      name: "market-language-inspirations-es"
    }, {
      path: "/:market/:language/s/inspiratie*",
      component: _63bd6b49,
      name: "market-language-inspirations-nl"
    }, {
      path: "/:market/:language/s/luminaires*",
      component: _52a6eaad,
      name: "market-language-lighting-fr"
    }, {
      path: "/:market/:language/s/leuchten*",
      component: _52a6eaad,
      name: "market-language-lighting-de"
    }, {
      path: "/:market/:language/s/illuminazioni*",
      component: _52a6eaad,
      name: "market-language-lighting-it"
    }, {
      path: "/:market/:language/s/lighting*",
      component: _52a6eaad,
      name: "market-language-lighting-en"
    }, {
      path: "/:market/:language/s/lighting*",
      component: _52a6eaad,
      name: "market-language-lighting-pt"
    }, {
      path: "/:market/:language/s/lamparas*",
      component: _52a6eaad,
      name: "market-language-lighting-es"
    }, {
      path: "/:market/:language/s/verlichting*",
      component: _52a6eaad,
      name: "market-language-lighting-nl"
    }, {
      path: "/:market/:language/s/atelier-deco*",
      component: _4b34c87e,
      name: "market-language-home-by-me-fr"
    }, {
      path: "/:market/:language/s/atelier-arredo*",
      component: _4b34c87e,
      name: "market-language-home-by-me-it"
    }, {
      path: "/:market/:language/s/taller-de-decoracion*",
      component: _4b34c87e,
      name: "market-language-home-by-me-es"
    }, {
      path: "/:market/:language/s/dekowerkstatt*",
      component: _4b34c87e,
      name: "market-language-home-by-me-de"
    }, {
      path: "/:market/:language/s/decor-workshop*",
      component: _4b34c87e,
      name: "market-language-home-by-me-en"
    }, {
      path: "/:market/:language/:alias/:slug",
      component: _3cb0debb,
      name: "market-language-editorial"
    }, {
      path: "/:market/:language/magasins/",
      component: _4aca05f8,
      name: "store-locator"
    }],
    fallback: false
  });
}